import React from 'react';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import TickedSlider from '../../../../../../../../../agencies/quotes/PrimeX/customizeQuote/components/TickedSlider';
import useTypingTimeout from '../../../../hooks/useTypingTimeout';
import CoverageOptionsLabel from '../../../../../../../../primeX-underwriter/components/amendatoryCoverages/components/shared/CoverageOptionsLabel';
import SelectBase from '../../../../../../../../primeX-underwriter/components/footer/SelectBase';

const LABEL_ID = 'amendCooperationPercentageLabel';

const AmendCooperation = (props: AmendatoryLineItemProps) => {
  // Raters send either a fixed list (p250x: `options`) or a range
  // (`from`/`to`/`step`). A slider over a list has no bounds to read.
  const percentageOptions = props.rules?.percentage?.options;
  const _sliderTo = props.rules?.percentage?.to;
  const _sliderFrom = props.rules?.percentage?.from;
  const hasOptions = Boolean(percentageOptions?.length);
  // An unselected clause in a midterm endorsement can arrive with no rule.
  const hasRange = !hasOptions && _sliderFrom != null && _sliderTo != null;

  const setPercentage = (newValue: number) => {
    props.setCoverage({
      id: props.id,
      value: { props: { percentage: { value: newValue } } },
    });
  };

  const handleChange = useTypingTimeout((newValue: number | number[]) => {
    setPercentage(newValue as number);
  });

  return (
    <CoverageOptionsWrapper>
      <CoverageOptionsLabel id={LABEL_ID} htmlFor="amendCooperationPercentage">
        Amend Cooperation % of Liability Expenses
      </CoverageOptionsLabel>
      {hasOptions && (
        <SelectBase
          name="amendCooperationPercentage"
          labelId={LABEL_ID}
          options={percentageOptions.map((option) => ({
            label: `${option}%`,
            value: option,
          }))}
          value={props.value?.props.percentage?.value ?? ''}
          disabled={!props.isSelected}
          onChange={(e) => setPercentage(Number(e.target.value))}
          sx={{
            '& .MuiSelect-select': {
              minHeight: '0.2rem',
              height: '0.50rem',
              width: '3rem',
            },
          }}
        />
      )}
      {hasRange && (
        <TickedSlider
          boxProps={{
            alignItems: 'center',
            gap: '1rem',
            width: '14rem',
          }}
          name="amendCooperationPercentage"
          onChange={handleChange.onChange}
          disabled={!props.isSelected}
          min={Number(_sliderFrom)}
          initialSliderValue={props.value?.props.percentage?.value as number}
          max={Number(_sliderTo)}
          step={props.rules?.percentage?.step}
        >
          {(value) => <>{value}%</>}
        </TickedSlider>
      )}
    </CoverageOptionsWrapper>
  );
};

export default AmendCooperation;
